import api from "./api";
// @ts-expect-error - api is not typed
const { post } = api.getPrefixedMethods("misc");
export const miscService = {
    regenerateS3Links: (s3Links) => {
        return post("regenerate-s3-links", { s3Links });
    },
};
